import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { AsambleaForm } from '@/features/asambleas/asamblea-form';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Button } from '@/components/ui/button';

export function NuevaAsambleaRoute() {
  const { condoId } = useCondoContext();
  const navigate = useNavigate();

  return (
    <PageContainer width="form">
      <Button variant="ghost" asChild size="sm" className="mb-4">
        <Link to={`/app/condominios/${condoId}/asambleas`}>
          <ArrowLeft className="h-4 w-4" />
          Volver
        </Link>
      </Button>
      <PageHeader
        eyebrow="Nueva convocatoria"
        title="Crear borrador de asamblea"
        subtitle="La Ley 21.442 exige al menos 15 dias de anticipacion para ordinarias y 3 dias para extraordinarias. Agrega las materias del orden del dia despues de crear el borrador."
        ruleSpacing="mb-8"
      />
      <AsambleaForm
        condoId={condoId}
        onCreated={(asambleaId) => navigate(`/app/condominios/${condoId}/asambleas/${asambleaId}`)}
      />
    </PageContainer>
  );
}
